window.onload = function(){
    if(srpInfo.root != 1){
        $('#summarysecond').html('');
        $('.error').show();
    }else{
        showData(srpInfo);
    }

    var data = {
        imgUrl:"http://mtest.zhongsou.com/img/wxshare/souyue_logo.png",
        title:$('title').text(),
        desc:"推荐你在搜悦中查阅“"+$('title').text()+"”，内容很精彩，值得关注",
        appId:appId,
        timestamp:timestamp,
        nonceStr: nonceStr,
        signature: signature
    };

    widgetShare(data);
}
function showData(data){
    var html = ztJSEngine(
        'page_summary_second',
        {data:data},
        {cacheMax:50}
    );
    $('#summarysecond').html(html);
}

//加载更多
function load_more_control(obj,k){
    var page_num = parseInt($(obj).attr('data-pn')),
        load_more_url = '';
    if (!page_num){
        page_num = 2;
    }
    //拼接请求地址

    load_more_url = "/Widgetshare/getSecondLists?keyword="+k+"&page="+page_num;
    //加载中的样式
    $(obj).hide();
    $(".more_loading_gif").show();
    $.ajax({
        type:'post',
        timeout : 30000, 
        url:load_more_url, 
        dataType:'json',
        success:function(json){
            if (json){
                var html = ztJSEngine(
                    'page_summarysecond_more',
                    {data:json},
                    {cacheMax:50}
                );
                $("#widget_render_content").find('.load_more_sign').append(html);
                $(obj).attr('data-pn', parseInt(page_num)+1);
                if($(obj).length){
                    $(obj).show();
                    $(".more_loading_gif").hide();
                }
            }
        },
        complete:function(XMLHttpRequest,status){
            if(XMLHttpRequest.status==0|| XMLHttpRequest.status>=500||status=='timeout' || status=='error'){
                $(".loading-div:visible").parent().html($("#error_network").html());
            }
        }
    });
}

$('.message_con').live('click',function(){
    var Dthis = this;
    changeColor(this);
    var url = $(this).attr('data-url'),
        keyword = $(this).attr('data-keyword'),
        isappinstalled = getQueryString(window.location.href,'isappinstalled') || 0,
        appname = getQueryString(window.location.href,'appname');
        setTimeout(function(){
            window.location.href = 'http://' + location.host + '/newsdetail/index?keyword=' + keyword + '&url=' + encodeURIComponent(url) + '&isappinstalled=' + isappinstalled + '&appname=' + appname;
            Dthis.style.background = '';
        },100);
});
window.onscroll = function(){
    var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
    if(scrollTop >= 800){
        $('.backtop').show();
    }else{
        $('.backtop').hide();
    }
}